import '../css/main.scss';




$(function () {

  if (window.matchMedia("(max-width: 768px)").matches) {

    // liの数を取得
    const listItems = $(".js-accordion-box li").length;


    $(".js-accordion-box").each(function () {
      // 最初に表示させるliの数
      let num = 3;
      // 閉じた時に表示させるliの数
      let closeNum = num - 1;
      // 最初はもっと見るボタン表示、閉じるボタン非表示
      $(this).find(".js-btn-more").show();
      $(this).find(".js-btn-close").hide();
      // 6行目まで表示
      $(this)
        .find("li:not(:lt(" + num + "))")
        .hide();
      // もっと見るボタンがクリックされた時
      $(".js-btn-more").click(function () {
        // numに+4ずつしていく = 4行ずつ追加する
        num += 4;
        $(this)
          .parent()
          .find("li:lt(" + num + ")")
          .slideDown();
        // liの数よりnumが多い時、
        if (listItems <= num) {
          // もっと見るボタン非表示
          $(".js-btn-more").hide();
          // 閉じるボタン表示
          $(".js-btn-close").show();
          // 閉じるボタンがクリックされたら、
          $(".js-btn-close").click(function () {
            $(this).parent().find("li:gt(" + closeNum + ")")
              // 6行目以降は非表示
              .slideUp();
            // 閉じるボタンを非表示
            $(this).hide();
            // もっと見るボタン表示に
            $(".js-btn-more").show();
            num = 3;
          });
        }
      });
    });

  } else {
    $(".js-accordion-box").each(function () {
      $(this).find(".js-btn-more").hide();
      $(this).find(".js-btn-close").hide();
    });
  };


});


// sns
let url = location.href
let snsLinks = $(".js-sns-link")
for (let i = 0; i < snsLinks.length; i++) {
  let href = snsLinks.eq(i).attr('href');
  //シェアページのURL上書き
  href = href.replace("u=", "u=" + url)     //facebook
  href = href.replace("url=", "url=" + url) //twitter,LINE,はてなブログ,ピンタレスト
  snsLinks.eq(i).attr('href', href);
}